'use client';

import Image from 'next/image';
import { memo } from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export const Logo = memo(({ width = 50, height = 50, className = '' }: LogoProps) => {
  return (
    <Image
      src="/ANTIRUGv2Mini.svg"
      alt="Anti Rug Agent Logo"
      width={width}
      height={height}
      className={className}
      priority
    />
  );
});
